import { fmtMoney } from '../lib/format';
import type { Totals4 } from '../lib/totals';

// Renders the headline "Net" row used at the bottom of the operating
// expense table and at the bottom of each project block. Year-column
// tints come from the .col-current / .col-shade classes (colspan-safe).
export function NetRow({
  label,
  values,
  actual,
}: {
  label: string;
  values: Totals4;
  actual: number | null;
}) {
  const cls = (n: number) => `net-value num ${n >= 0 ? 'pos' : 'neg'}`;
  return (
    <tr className="row-net">
      <td colSpan={5}>
        <span className="net-label">{label}</span>
      </td>
      <td className="col-actual text-right">
        {actual === null ? (
          <span className="text-ccaanz-grey num">—</span>
        ) : (
          <span className={cls(actual)}>{fmtMoney(actual)}</span>
        )}
      </td>
      <td className="col-current text-right">
        <span className={cls(values.current)}>{fmtMoney(values.current)}</span>
      </td>
      <td className="col-shade text-right">
        <span className={cls(values.y1)}>{fmtMoney(values.y1)}</span>
      </td>
      <td className="text-right">
        <span className={cls(values.y2)}>{fmtMoney(values.y2)}</span>
      </td>
      <td className="col-shade text-right">
        <span className={cls(values.y3)}>{fmtMoney(values.y3)}</span>
      </td>
      <td className="no-print"></td>
    </tr>
  );
}
